var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var DownloadCloud24 = function DownloadCloud24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.46 9.531a1.011 1.011 0 0 1-.57-.73 6.992 6.992 0 0 0-13.78 0 1.012 1.012 0 0 1-.57.73 5.987 5.987 0 0 0-3.5 6.17A6.132 6.132 0 0 0 7.21 21h9.58a6.132 6.132 0 0 0 6.17-5.3 5.988 5.988 0 0 0-3.5-6.169zm-2.75 4.18-4 4a1.014 1.014 0 0 1-1.42 0l-4-4a1.004 1.004 0 0 1 1.42-1.42l2.29 2.3V9a1 1 0 1 1 2 0v5.59l2.29-2.3a1.004 1.004 0 1 1 1.42 1.421z",
    fill: "currentColor"
  }));
};

DownloadCloud24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': DownloadCloud24
};
export var DownloadCloud = function DownloadCloud(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'DownloadCloud' icon. Please use one of the available sizes: '24'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};